import React, { useState } from "react";
import { Grid } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import Switch from "@mui/material/Switch";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAlertContext } from "src/hooks/use-alert";
import { DeleteSite } from "src/apis/complex";
import DailogContainer from "../DailogContainer";

function ComplexList({ complexes }) {
  const navigate = useNavigate();
  const alert = useAlertContext();

  const [newComplexes, setNewComplexes] = useState(complexes);
  const [deleteDetailOpen, setDeleteDetailOpen] = useState(false);
  const [deleteComplexInfo, setDeleteComplexInfo] = useState("");
  const [deleteText, setDeleteText] = useState("");

  const handleDelete = (complex) => {
    if (complex.buildings.length > 0) {
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          message:
            "Cannot delete " +
            complex.name +
            " because it has " +
            complex.buildings.length +
            " buldings in it.",
        },
      ]);
    } else {
      setDeleteDetailOpen(true);
      setDeleteComplexInfo(complex.id);
      setDeleteText("Are you sure you want to delete this site?");
    }
  };

  // Callback function to confirm the delete in child component
  const handleConfirmChange = () => {
    handleConfirmDelete();
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await DeleteSite(deleteComplexInfo);
      if (response.success === true) {
        // Remove the deleted site from the complexes list
        setNewComplexes((prevComplexes) =>
          prevComplexes.filter(
            (eachComplex) => eachComplex.id !== deleteComplexInfo
          )
        );

        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Site deleted succesfully",
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          {
            status: true,
            messages: "Deletion not succesfull",
            index: prev.length,
          },
        ]);
      }
    } catch (error) {
      console.error("Error deleting site:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: "Error deleting site",
          index: prev.length,
        },
      ]);
    }
    setDeleteDetailOpen(false);
  };

  return (
    <>
      {newComplexes && newComplexes.length >0 && newComplexes.map((complex) => (
        <Grid
          key={complex.name + complex.id}
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          paddingTop={"5px"}
          paddingRight={"5px"}
        >
          <div className="complexView">
            <div className="complexButton">
              <ButtonPolicy
                onClick={() => navigate(`/dashboard/explore-complexes/${complex.id}`)}
                variant="text"
              >
                <h2>{complex.name}</h2>
              </ButtonPolicy>
            </div>
            <div className="Info">{complex.description}</div>
            <div className="switchHolder">
              <div className="switches">
                <div className="leftSwitch">
                  <div>Energy Saving</div>
                  <Switch />
                </div>
                <div className="rightSwitch">
                  <div>Fault Prediction</div>
                  <Switch />
                </div>
                <div className="deleteIcon">
                  <ButtonPolicy onClick={() => handleDelete(complex)}>
                    <DeleteIcon sx={{color: "white"}} />
                  </ButtonPolicy>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      ))}

      {deleteDetailOpen && (
        <DailogContainer
          detailOpen={deleteDetailOpen}
          setDetailOpen={setDeleteDetailOpen}
          text={deleteText}
          onToggleChange={handleConfirmChange}
        />
      )}
    </>
  );
}

export default ComplexList;
